module.exports = __webpack_public_path__ + "@/assets/img/logo.18a9b540.png";